import useResponsive from "Context/useResponsive";
import React from "react";
import styled from "styled-components";

interface UnmarkedLectureCountProps {
  count?: number;
  label?: string;
  icon?: React.ReactNode;
  isActive?: boolean;
  onClick?: () => void;
}

interface StyledProps {
  $isActive?: boolean;
  isMobile?: boolean;
}

const Container = styled.div<StyledProps>`
  display: inline-flex;
  align-items: center;
  padding: 6px 6px 6px 6px;
  border: 1.5px solid
    ${(props: any) => (props.$isActive ? "#334155" : "#e2e8f0")};
  border-radius: 10px;
  background-color: ${(props: any) =>
    props.$isActive ? "#f8fafc" : "#ffffff"};
  height: ${(props: any) => (props.isMobile ? "24px" : "36px")};
  cursor: pointer;
  transition: all 0.2s;
`;

const IconWrapper = styled.div<StyledProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f1f5f9;
  border-radius: 12px;
  width: 24px;
  height: 24px;
  color: ${(props: any) => (props.$isActive ? "#334155" : "#64748b")};

  font-size: 18px;
`;

const Label = styled.span`
  font-weight: 600;
  font-size: 13px;
  color: #334155;
  margin: 0 10px;
`;

const Badge = styled.div<StyledProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props: any) =>
    props.$isActive ? "#334155" : "#f1f5f9"};
  color: ${(props: any) => (props.$isActive ? "#ffffff" : "#475569")};

  font-weight: 500;
  font-size: 13px;
  padding: 0 8px;
  height: 20px;
  border-radius: 20px;
  min-width: 36px;
`;

const UnmarkedLectureCount: React.FC<UnmarkedLectureCountProps> = ({
  count = 0,
  label = "",
  icon,
  isActive = false,
  onClick,
}) => {
  const { isMobile } = useResponsive();
  return (
    <Container $isActive={isActive} onClick={onClick} isMobile={isMobile}>
      {icon && <IconWrapper $isActive={isActive}>{icon}</IconWrapper>}
      <Label>{label}</Label>
      {!!count && <Badge $isActive={isActive}>{count}</Badge>}
    </Container>
  );
};

export default UnmarkedLectureCount;
